module.exports = __webpack_public_path__ + "img/sora.0c014b4b.jpg";